import type { FulfillmentEngineAddress, FulfillmentEngineSearchPlansV1Params } from '@shipium-corp/shipium-ts-types';
import type { FulfillmentEngineSearchValues } from './FulfillmentEngineSearch';
import { ShipiumTag } from '../../components/shared/ShipiumTag';

export const EMPTY_TEXT_DEFAULT = 'Click Search to show results.';
export const NO_RESULTS_TEXT = 'No results found.';

const formatBaseSearchRequest = (
  searchRequest: FulfillmentEngineSearchValues,
  type: FulfillmentEngineSearchPlansV1Params['dateRangeSearchType'],
  idKey: 'planId' | 'orderId' | 'partnerOrderId' | 'proposedShipmentId',
): FulfillmentEngineSearchPlansV1Params => {
  const { searchValue, fulfillmentContextId, dateRange } = searchRequest;
  const [start, end] = dateRange || [];

  return {
    dateRangeSearchType: type,
    ...(searchValue && { [idKey]: [searchValue] }),
    ...(fulfillmentContextId && {
      fulfillmentContextId: [fulfillmentContextId],
    }),
    ...(start && {
      dateTimeFrom: start.toISOString(),
    }),
    ...(end && {
      dateTimeTo: end.toISOString(),
    }),
  };
};

export const formatPlanSearchRequest = (
  searchRequest: FulfillmentEngineSearchValues,
): FulfillmentEngineSearchPlansV1Params => {
  return formatBaseSearchRequest(searchRequest, 'plans', 'planId');
};

export const formatOrderSearchRequest = (
  searchRequest: FulfillmentEngineSearchValues,
): FulfillmentEngineSearchPlansV1Params => {
  return formatBaseSearchRequest(searchRequest, 'orders', 'orderId');
};

export const formatPartnerOrderSearchRequest = (
  searchRequest: FulfillmentEngineSearchValues,
): FulfillmentEngineSearchPlansV1Params => {
  return formatBaseSearchRequest(searchRequest, 'orders', 'partnerOrderId');
};

export const formatShipmentSearchRequest = (
  searchRequest: FulfillmentEngineSearchValues,
): FulfillmentEngineSearchPlansV1Params => {
  return formatBaseSearchRequest(searchRequest, 'plans', 'proposedShipmentId');
};

// address formatting yay!
// similar to src/components/fulfillmentContext
const addressLine = (id: string, line?: string) => {
  if (line) {
    return <li key={id}>{line}</li>;
  }
};

export const formatFulfillmentAddressLocationItemsForList = (location?: FulfillmentEngineAddress) => {
  return (
    <>
      {addressLine(`company`, location?.company)}
      {addressLine(`street-1`, location?.street1)}
      {addressLine(`street-2`, location?.street2)}
      <li key={`address-3`}>
        {location?.city}, {location?.region} {location?.postalCode} {location?.countryCode}
      </li>
    </>
  );
};

export const formatFulfillmentAddressAsList = (address?: FulfillmentEngineAddress, fullDetail = false) => {
  return address ? (
    <ul style={{ listStyleType: 'none', padding: 0, margin: 0 }}>
      {fullDetail ? addressLine(`${address.name}-name`, address.name) : undefined}
      {formatFulfillmentAddressLocationItemsForList(address)}
    </ul>
  ) : (
    <ShipiumTag style={{ fontSize: 10, padding: 4, lineHeight: '10px' }} color={'Gold'}>
      No Address Configured
    </ShipiumTag>
  );
};
